import { NotificationsRes, Type } from '@/api/types/notificationsType';

const NOTIFICATION_TYPES = new Set<string>(Object.values(Type));

export const isNotificationRecord = (
  value: unknown
): value is NotificationsRes => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const record = value as NotificationsRes;

  return (
    typeof record.id === 'number' &&
    typeof record.body === 'string' &&
    typeof record.type === 'string' &&
    NOTIFICATION_TYPES.has(record.type)
  );
};

export const normalizeApiNotifications = (
  items: unknown[]
): NotificationsRes[] => {
  return items.filter(isNotificationRecord);
};
